import { render, staticRenderFns } from "./DynamicElements.vue?vue&type=template&id=0105ebfa&scoped=true&"
import script from "./DynamicElements.vue?vue&type=script&lang=js&"
export * from "./DynamicElements.vue?vue&type=script&lang=js&"
import style0 from "./DynamicElements.vue?vue&type=style&index=0&id=0105ebfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0105ebfa",
  null
  
)

export default component.exports